import { notify } from '@kyvg/vue3-notification'

export const showSuccessNotification = (title: string) => {
	notify({
		type: 'success',
		title,
	})
}
